import { CampaignSource, CampaignSubSource } from 'utils/constants/campaign';

export enum BannerModerationStatus {
    New = 'NEW',
    Moderated = 'MODERATED',
    Banned = 'BANNED',
}

export const BANNER_NEW_LINE_WARNING = 'NEW_LINE_WARNING';
export const BANNER_RED_LINE_WARNING = 'RED_LINE_WARNING';
export const BANNER_NEW_AND_RED_LINE_WARNING = 'NEW_AND_RED_LINE_WARNING';
export const IS_UPSCALE_TIP_WAS_SHOWN = 'IS_UPSCALE_TIP_WAS_SHOWN';

export const BANNER_WARNING_TRL_KEYS = {
    [BANNER_NEW_LINE_WARNING]: 'AdCreate.AdForm.BannerText.warning.newLine',
    [BANNER_RED_LINE_WARNING]: 'AdCreate.AdForm.BannerText.warning.redLine',
    [BANNER_NEW_AND_RED_LINE_WARNING]: 'AdCreate.AdForm.BannerText.warning.newAndRedLine',
};

const NEW_LINE_REGEXP = /[\n]/g;
const RED_LINE_REGEXP = /[\t]/g;

export const checkBannerText = (text: string): { warningTrlKey: string; text: string } => {
    let warningTrlKey = '';
    if (text.match(NEW_LINE_REGEXP)) {
        text = text.replace(NEW_LINE_REGEXP, ' ');
        warningTrlKey = BANNER_WARNING_TRL_KEYS[BANNER_NEW_LINE_WARNING];
    }
    if (text.match(RED_LINE_REGEXP)) {
        text = text.replace(RED_LINE_REGEXP, '');
        warningTrlKey =
            BANNER_WARNING_TRL_KEYS[warningTrlKey === '' ? BANNER_RED_LINE_WARNING : BANNER_NEW_AND_RED_LINE_WARNING];
    }
    return {
        warningTrlKey,
        text,
    };
};

export enum BannerImageCropType {
    HH = 'TARGET_DEFAULT',
    VK = 'MY_TARGET_DEFAULT',
    YandexAndVK = 'VK_DEFAULT',
}

export const BANNER_IMAGE_CROP_DEFAULT = BannerImageCropType.HH;

export const BANNER_IMAGE_CROP_TYPES = [
    BannerImageCropType.HH,
    BannerImageCropType.YandexAndVK,
    BannerImageCropType.VK,
];

export const BANNER_IMAGE_CROP_TYPES_CONFIG = {
    [BannerImageCropType.HH]: {
        minWidth: 180,
        minHeight: 150,
        aspect: 1.2,
        // exp_PORTFOLIO-53635_next_line
        sources: [CampaignSubSource.HH, CampaignSubSource.HHTopSearch, CampaignSubSource.HHBanners],
    },
    [BannerImageCropType.YandexAndVK]: {
        minWidth: 1080,
        minHeight: 607,
        aspect: 1080 / 607,
        sources: [
            CampaignSource.VKAds,
            CampaignSource.Yandex,
            CampaignSubSource.VK,
            CampaignSubSource.Social,
            CampaignSubSource.YandexSearch,
            CampaignSubSource.YandexNetwork,
            CampaignSubSource.VKAdsVK,
            CampaignSubSource.VKAdsOK,
            CampaignSubSource.VKAdsNetwork,
            CampaignSubSource.VKAdsProject,
        ],
    },
    [BannerImageCropType.VK]: {
        minWidth: 600,
        minHeight: 600,
        aspect: 1,
        sources: [
            CampaignSource.VKAds,
            CampaignSubSource.Social,
            CampaignSubSource.VKAdsVK,
            CampaignSubSource.VKAdsOK,
            CampaignSubSource.VKAdsNetwork,
            CampaignSubSource.VKAdsProject,
        ],
    },
};

export enum ImageType {
    Gallery = 'GALLERY',
    User = 'USER',
}

export enum ImageComponent {
    Input = 'INPUT',
    Loading = 'LOADING',
    Crop = 'CROP',
}

export enum UpscaleStatus {
    None = 'NONE',
    Upscale = 'UPSCALE',
    UpscaleAndFill = 'UPSCALE_AND_FILL',
}

export enum AiImageQueueType {
    Upscale = 'UPSCALE',
    UpscaleAndFill = 'UPSCALE_AND_FILL',
}

export enum AiImageQueueStatus {
    New = 'NEW',
    InProgress = 'IN_PROGRESS',
    Success = 'SUCCESS',
    Error = 'ERROR',
    Cancelled = 'CANCELLED',
}

export enum LimitBannerContent {
    Title = 25,
    Text = 70,
}

export const ACCEPT_VIDEO_EXTENSIONS = ['video/mp4', 'video/quicktime'];
export const ACCEPT_VIDEO_EXTENSIONS_MAGRITTE = {
    'video/*': ['.mp4', '.qt'],
};
export const MAX_VIDEO_SIZE = 100 * 1024 * 1024;
export const BANNER_ID_URL_FIELD_NAME = 'bannerId';
export const CROP_CONTAINER_SIZE = 370;
export const ACCEPT_IMAGE_EXTENTIONS = ['image/jpeg', 'image/png'];
export const ACCEPT_IMAGE_EXTENTIONS_MAGRITTE = {
    'image/*': ['.jpg', '.jpeg', '.png'],
};
